import {v4 as uuidv4, v5 as uuidv5} from "uuid";
import type {CookieRef} from "#app/composables/cookie";

export const useUuid = () => {
  const setupUuid = (userIdent?: string):CookieRef<string|null|undefined> => {
    const runtimeConfig = useRuntimeConfig()
    const userUuid = useCookie(runtimeConfig.public.uuidCookieName)
    // logged user
    if (userIdent) {
      const userUuidIdent = uuidv5(userIdent, uuidv5.URL)
      if (!userUuid.value || userUuid.value !== userUuidIdent) {
        userUuid.value =  userUuidIdent
      }
    } else if (!userUuid.value) {
      // anonymous user
      userUuid.value =  uuidv4()
    }
    return userUuid
  }

  return {
    setupUuid
  }
}


